<div #sliderContainer (click)="onClick()"
     (keydown)='onKeydown($event)'
     [class.hideSliderPointer]="hideSliderPointer"
     [class.hideValueBubble]="hideValueBubble"
     id="slider-container">
    <ng5-slider *ngIf="showSlider" [(value)]="acModel" (valueChange)="onChange()" [options]="_options" id="ng5Slider"></ng5-slider>
</div>
